const initialState = {
    location: {
        pathname: '',
    },
};

const actions = {
    HISTORY_UPDATE: (state, {payload: {location}}) => ({
        ...state,
        location,
    }),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
